import { render, staticRenderFns } from "./SliceScrollPoint.vue?vue&type=template&id=2c69bb0e&lang=pug&"
import script from "./SliceScrollPoint.vue?vue&type=script&lang=js&"
export * from "./SliceScrollPoint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports